module.exports = __webpack_public_path__ + "static/smooth-integration-ede71fb76129256919035bd5d976a67a.png";